import { areaUserPermission } from '../../api/uums';
import { localDataPermission,localDataPermissionByareaCode } from '@iebdc/utils/local-data';
import { getCookie } from '@iebdc/utils/cookies';
/**
 * permission store
 * @description
 * 权限的状态存储
 */
export default {
  state: {
    permission: localDataPermission.get() || []
  },
  getters: {
    //判断是否有权限
    hasPermission(state, permission) {
      return function(key) {
        return permission.includes(key);
      };
    }
  },
  mutations: {
    setPermission(state, permission) {
      state.permission = permission;
    }
  },
  actions: {
    getPermission({ commit }, userId = null) {
      //在获取完省厅的permission之后,再获取当前区域code的permission的集合,来判断是否显示抵押合同IEBDC:SQ:DYHT
      const params = [{ areaCode: window.CONFIG.code, userId },{ areaCode: getCookie('selectedAreaCode'), userId }];
      params.map((item,index) => {
        areaUserPermission(item).then((res) => {
          const { data } = res;
          if (!data || data.length === 0) {
          	console.error('[ERROR] 严重错误！！！');
          } else {
			  let permission = data.map((item) => item.permValue);
			  if(index == 0){
				  localDataPermission.set(permission);
				  commit('setPermission', permission);
			  }else{
				  localDataPermissionByareaCode.set(permission);
			  }
		  }
        });
      })
    }
  }
};
